import { HONORED_LIST, HONORED_ADDEDIT, HONORED_CHANGE_STATUS, HONORED_DELETE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const honoredListApi = (payload) => {
    return apiInstance.post(HONORED_LIST, payload, {
        headers: authHeader(),
    });
};

export const honoredChangeStatusApi = (payload) => {
    return apiInstance.post(HONORED_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditHonoredApi = (payload) => {
    return apiInstance.post(HONORED_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const honoredDeleteApi = (payload) => {
    return apiInstance.post(HONORED_DELETE, payload, {
        headers: authHeader(),
    });
};